import type { InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

interface PasswordFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  inputClassName?: string;
  toggleButtonTestId?: string;
}

export function PasswordField({
  className,
  inputClassName,
  toggleButtonTestId,
  ...props
}: PasswordFieldProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={className}>
      <div className="relative">
        <input
          {...props}
          className={["input-field pr-12", inputClassName].filter(Boolean).join(" ")}
          type={isVisible ? "text" : "password"}
        />
        <button
          aria-label={isVisible ? "Hide password" : "Show password"}
          aria-pressed={isVisible}
          className="absolute right-2 top-1/2 inline-flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-xl text-slate transition duration-200 hover:bg-cloud hover:text-navy focus:outline-none focus-visible:ring-4 focus-visible:ring-royal/10"
          data-testid={toggleButtonTestId}
          onClick={() => setIsVisible((current) => !current)}
          type="button"
        >
          {isVisible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
}
